const FRI_TABS_HEIGHT = 108;
const EQUIPMENT_TABS_HEIGHT = 48;
export { EQUIPMENT_TABS_HEIGHT };
export default FRI_TABS_HEIGHT;
